import { OfficeLocations } from 'components/Pages/AboutUsPage/OfficeLocationModal/OfficeLocationModal'

export type RetailStoreType = 'bondi' | 'chadstone'

export const STORE_CAMPAIGN_URL = '/campaign/store'

const RETAIL_STORE_LOCATIONS: Record<RetailStoreType, OfficeLocations> = {
  bondi: OfficeLocations.BONDI,
  chadstone: OfficeLocations.CHADSTONE,
}

export function getRetailStoreLocation(storeType: RetailStoreType): OfficeLocations {
  return RETAIL_STORE_LOCATIONS[storeType]
}
